import { useState } from "react";
import Input, { type InputProps } from "./Input";
import Checkbox from "./Checkbox";

interface PasswordInputProps extends Omit<InputProps, "type"> {
  includeChecklist?: boolean;
}

const PasswordInput = (props: PasswordInputProps) => {
  const [hidden, setHidden] = useState(true);

  return (
    <div>
      <Input {...props} type={!hidden ? "text" : "password"}></Input>
      <Checkbox
        id={`${props.id}-checkbox`}
        label="Show password"
        checked={!hidden}
        onChange={() => setHidden(!hidden)}
      />
    </div>
  );
};

export default PasswordInput;
